import classNames from 'classnames';
import React from 'react';
import { Text } from '@typedream/ui';
import styles from './SearchBar.module.css';

type SearchBarProps = React.PropsWithChildren<{
  value?: string; // if you want this component to be controlled
  defaultValue?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  placeholder: string;
  prefixComponent?: React.ReactNode;
  className?: string;
}>;

export function SearchBar({
  placeholder,
  children,
  value,
  defaultValue,
  prefixComponent,
  onChange,
  className,
}: SearchBarProps) {
  return (
    <div
      className={classNames(
        'relative w-full rounded-lg bg-background-tertiary px-3 py-2 gap-2 flex items-center text-primary',
        className
      )}
    >
      {prefixComponent}
      <Text variant="main" size="xs" weight="regular">
        <input
          className={classNames(styles.searchInput, 'placeholder:text-secondary')}
          type="text"
          placeholder={placeholder}
          onChange={onChange}
          defaultValue={defaultValue}
          value={value}
        />
      </Text>
      {children}
    </div>
  );
}

SearchBar.defaultProps = {
  value: undefined,
  defaultValue: undefined,
  onChange: undefined,
  prefixComponent: undefined,
  className: undefined,
};
